module.exports = __webpack_public_path__ + "img/icon-number-eight.57474017.svg";